export const STATIC_DOMAIN = 'https://www.eyespy360.com/';
export function staticUrl(path) {
    const cid = typeof window !== 'undefined' && window._e3cid;
    return `${STATIC_DOMAIN}${path}${cid ? '?companyID=' + cid : ''}`;
}
export const RESOLUTION_SCALE_HIGH = 0.4;
export const RESOLUTION_SCALE_LOW = 0.3;

export const UNIT_MILLIMETER = 'mm';
export const UNIT_CENTIMETER = 'cm';
export const UNIT_METER = 'm';
export const UNIT_INCH = 'in';
export const UNIT_FOOT = 'ft';
export const UNIT_MILE = 'mi';

export const OPACITY_INTERNAL_WALLS = 1;
export const OPACITY_EXTRENAL_WALLS = 0.1;

export const KEY_KODES = {
    up: 1500,
    right: 1501,
    down: 1502,
    left: 1503,

    zoom_in: 1510,
    zoom_out: 1511,
};


export const UNIT_COEF = {
    [UNIT_MILLIMETER]: 0.1,
    [UNIT_CENTIMETER]: 1,
    [UNIT_METER]: 100,
    [UNIT_INCH]: 2.54,
    [UNIT_FOOT]: 30.48,
    [UNIT_MILE]: 160934.4,
};
